var MediaQueryDispatch = require('./MediaQueryDispatch');
module.exports = new MediaQueryDispatch();



// WEBPACK FOOTER //
// webpack://vue-slick-carousel/node_modules/enquire.js/src/index.js